// Libellés et couleurs de l'écran d'e-reporting (valeurs renvoyées par ms-invoice-transmission, qui lit la plateforme SuperPDP)

export const E_REPORTING_FLOW_LABELS = {
    transaction: "Transaction",
    payment: "Paiement"
};

export const E_REPORTING_FLOW_PLURAL_LABELS = {
    transaction: "Transactions",
    payment: "Paiements"
};

export const E_REPORTING_SCOPE_LABELS = {
    b2c: "Particuliers (B2C)",
    international: "International (B2B)"
};

// Catégories de transaction connues ; un autre code est affiché tel que la plateforme le renvoie
export const E_REPORTING_CATEGORY_LABELS = {
    TPS1: "Prestation de services",
    TNT1: "Non soumis à la TVA",
    TLB1: "Livraison de biens",
    TMA1: "Régime de la marge"
};

export const E_REPORTING_DOCUMENT_LABELS = {
    "invoice": "Facture",
    "deposit": "Acompte",
    "credit-note": "Avoir"
};

export const E_REPORTING_PAYMENT_TYPE_LABELS = {
    CASH: "Espèces",
    CHECK: "Chèque",
    TRANSFER: "Virement"
};

export const E_REPORTING_VAT_REGIME_LABELS = {
    monthly: "Réel normal mensuel",
    quarterly: "Réel normal trimestriel",
    simplified: "Réel simplifié",
    vat_exemption: "Franchise en base de TVA"
};

// Colonne "État" d'une déclaration : en cours de traitement = bleu (information), acceptée = vert, en erreur = rouge
export const E_REPORTING_DECLARATION_STATUS = {
    sent: {label: "Envoyée", color: "#1F3A63", backgroundColor: "#E4EEFC"},
    acknowledged: {label: "Accusé de réception", color: "#1F3A63", backgroundColor: "#E4EEFC"},
    accepted: {label: "Acceptée", color: "#1b5e20", backgroundColor: "#d7efdc"},
    ack_error: {label: "Accusé en erreur", color: "#a61b1b", backgroundColor: "#fde0e0"},
    rejected: {label: "Rejetée", color: "#a61b1b", backgroundColor: "#fde0e0"},
    unknown: {label: "Statut inconnu", color: "#1F3A63", backgroundColor: "#ffffff"}
};

// Colonne "État" d'une opération : à déclarer = bleu (information), déclarée = vert
export const E_REPORTING_OPERATION_STATE = {
    pending: {label: "À déclarer", color: "#1F3A63", backgroundColor: "#E4EEFC"},
    declared: {label: "Déclarée", color: "#1b5e20", backgroundColor: "#d7efdc"}
};

export const E_REPORTING_SEVERITY = {
    error: {label: "À corriger", color: "#a61b1b"},
    warning: {label: "À vérifier", color: "#a85a00"},
    info: {label: "Information", color: "#2F5FA8"}
};

export function declarationStatus(status) {
    return E_REPORTING_DECLARATION_STATUS[status] || E_REPORTING_DECLARATION_STATUS.unknown;
}

export function formatEuro(value) {
    return Number(value || 0).toLocaleString("fr-FR", {style: "currency", currency: "EUR"});
}

// Montant connu ou tiret quand la plateforme ne le donne pas (un paiement n'a pas de hors taxe)
export function formatKnownEuro(value) {
    return value === undefined || value === null ? "—" : formatEuro(value);
}

// Jour AAAA-MM-JJ renvoyé par le back (jour UTC, sans heure)
export function formatDay(day) {
    return day ? new Date(`${day}T00:00:00Z`).toLocaleDateString("fr-FR", {timeZone: "UTC"}) : "";
}

export function formatDateTime(date) {
    return date ? new Date(date).toLocaleString("fr-FR", {dateStyle: "short", timeStyle: "short"}) : "";
}

export function formatPeriod(start, end) {
    if (!start || !end) return "";
    return start === end ? `le ${formatDay(start)}` : `du ${formatDay(start)} au ${formatDay(end)}`;
}

export function formatRate(rate) {
    return `${Number(rate || 0).toLocaleString("fr-FR", {maximumFractionDigits: 2})} %`;
}

export function categoryLabel(category) {
    if (!category) return "";
    return E_REPORTING_CATEGORY_LABELS[category] ? `${E_REPORTING_CATEGORY_LABELS[category]} (${category})` : category;
}

// "280,00 € HT à 20 % · 120,00 € TTC à 10 %" : ce que la plateforme connaît pour chaque taux
export function vatLinesSummary(lines) {
    return (lines || []).map(line => {
        const hasTaxable = line.taxableAmount !== undefined && line.taxableAmount !== null;
        return hasTaxable
            ? `${formatEuro(line.taxableAmount)} HT à ${formatRate(line.taxPercent)}`
            : `${formatKnownEuro(line.grossAmount)} TTC à ${formatRate(line.taxPercent)}`;
    }).join(" · ");
}

// "Facture FAC-21", "Avoir FAC-30" ; "Facture n° 419486 (plateforme)" quand la plateforme ne donne pas le numéro et que le document n'est pas connu
export function documentLabel(operation) {
    const label = E_REPORTING_DOCUMENT_LABELS[operation.documentType] || "Document";
    if (operation.documentNumber) return `${label} ${operation.documentNumber}`;
    return operation.invoiceId ? `${label} n° ${operation.invoiceId} (plateforme)` : label;
}
